const COMPANIES = {
    listCompanies: "Lista de empresas",
    newCompany: "Nueva Compañía",
    updateCompany: "Actualizar Compañía",
    id: "ID",
    name: "Nombre",
    ExpiredTo: "Vigente hasta",
    state: "Estado",
    accions: "Acciones",

    "delete": "Eliminar",
    edit: "Editar",
    accept: "Aceptar",
    cancel: "Cancelar",
    update: "Actualizar",

    titleAlert: "Eliminar Empresa:",
    messageAlert: "Ésta opción no se puede deshacer, está seguro?",

    nit: "Nit",
    addressCompany: "Dirección de la empresa",
    contactEmail: "Email de contacto",
    nameCompany: "Nombre de la empresa",
    personContact: "Persona de contacto",
    numberMovil: "Número celular",
    department: "Departamento",
    city: "Ciudad",
    contractDate: "Fecha de contrato",
    expiredDate: "Fecha de expiración",
    languages: "Idioma (locale)",

    titleCard: "Servicios contratados",
    module: "Módulo",
    yes: "Sí",
    multiForms: "Multiformularios",
    subForms: "Subformularios",
    moduleAnswer: "Modulo respuesta",
    dataSource: "Origen de datos",
    notify: "Notificaciones",
    connectServi: "Conección a ServiForms",
    appServi: "App ServiForms",
    filterExportData: "Filtro y exportación de datos",
    accessApi: "Acceso API ServiForms",
    showCase: "Showcase",
    Bots: "Bots",
    visits: "Visitas",
    Dispatcher: "Dispatcher",

    settingDispatcher: "Conguración Dispatcher",
    enterToken: "Ingrese token del API",
    EnterUrl: "Ingrese url del API",

    btnCreate: "Crear",
    btnClean: "Limpiar",

    selectedDate: "Seleccione Fecha",

    companies: "Empresas",
    errorQueryCompanies: "Ocurrio un error, al consultar la lista de Empresas",
    deleteCompany: "Eliminar empresas",
    errorDeleteCompany: "Ocurrio un error, al eliminar la empresa",
    actionDisabled: "Acción no disponible de momento",
    company: "Compañía",

    successCompany: "Se ha creado la compañía.",
    updateSuccess: "Se ha actualizado la compaía.",
    alertDateExpired: "La fecha de expiración debe ser mínimo de una semana."

}

export default { COMPANIES };